import MembershipCancellationForm from '../../components/membership_cancellations/membership_cancellation_form';

angular.module('gym').value('MembershipCancellationForm', MembershipCancellationForm);
